import steps from '~/languages/en/help/delivery/steps.js';
import additional from '~/languages/en/help/delivery/additional.js';

export default {
  title: {
    base: 'Prescription',
    keyword: 'delivery to your door',
  },
  steps,
  additional,
};
